// components/ObjectMarker.jsx
import { useState } from "react";
import clsx from "clsx"; // tiny helper to merge class names (npm i clsx)

export default function ObjectMarker({
  left,
  top,
  title,
  phone,
  email,
  address,
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="object-label"
      style={{ left, top }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={() => setOpen((o) => !o)} // tap-to-toggle for mobile
    >
      <div className={clsx("object-info", { in: open })}>
        <h3 className="object-title">{title}</h3>
        <div className="object-content">
          {phone}
          <br />
          {email}
          <br />
          {address}
        </div>
      </div>
    </div>
  );
}
